import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthServiceHelper } from '../../providers/services/auth.service';
import { environment } from '../../../environments/environment';
import { OtpService } from '../../providers/services/otp.service';
import { UserContextService } from '../../providers/services/user-context.service';
import { LOGINTYPE } from '../../constants/helper-constant';
import { isTabView } from '../../utils';

@Component({
  selector: 'app-tenant-list',
  templateUrl: './tenant-list.component.html',
  styleUrl: './tenant-list.component.scss',
})
export class TenantListComponent implements OnInit {
  public tenantList: any;
  public avatarSize = 48;
  public avatarInitialCount = 1;
  public emailId: any;
  public isTabView: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private authServiceHelper: AuthServiceHelper,
    private router: Router,
    private otpService: OtpService,
    private userContextService: UserContextService
  ) {
    this.isTabView = isTabView();
  }

  // -------------------------------------------------------------------------
  // Lifecycle methods

  public ngOnInit() {
    this.emailId = this.activatedRoute.snapshot.queryParams['emailId'];
    this.authServiceHelper.accounts(this.emailId).then((response) => {
      this.tenantList = response;
      if (response.length === 1) {
        const tenantRequest = response[0];
        this.doTenantLogin(tenantRequest);
      }
    });
  }

  /**
   * @function goBack
   * validateForm method used to navigate back
   */
  public async goBack() {
    this.router.navigate(['/login']);
  }

  /**
   * @function doTenantLogin
   * validateForm method used to login with tenant
   */
  public async doTenantLogin(tenant: any) {
    if (tenant.login_type === LOGINTYPE.SERVER2SERVER) {
      const data = { email: this.emailId }
      await this.otpService.sendOtp(data, true).then(() => {
        this.userContextService.setContact({
          contact: this.emailId,
          contactType: 'email'
        })
        this.router.navigate(['/login'], {
          queryParams: {
            emailId: this.emailId,
            otp: true,
            cred: tenant?.cred
          },
        })
      });
    } else {
      const url = `${environment.tenantUrl}${tenant.tenant_short_name}?appId=${environment.appId}`;
      window.location.href = url;
    }
  }

  /**
   * @function getInitials
   * validateForm method used to get initials of name
   */
  public getInitials(name: string): string {
    if (!name) return '';
    const words = name.split(' ');
    return words.length > 1 ? words[0][0] + words[1][0] : words[0][0];
  }
}